import { FC, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Container, LanguagesSelect } from 'views/components';

import { FirstStepClinic } from './StepsContent/clinic/FirstStep';
import { ThirdStepClinic } from './StepsContent/clinic/ThirdStep';
import { FourStepClinic } from './StepsContent/clinic/FourStep';

import { FirstStepCompany } from './StepsContent/company/FirstStep';
import { ThirdStepCompany } from './StepsContent/company/ThirdStep';
import { FourStepCompany } from './StepsContent/company/FourStep';

import { SecondStep } from './StepsContent/general/SecondStep';

import { RootState } from 'types';
import { dispatch } from 'store';
import { clearAuthError } from 'modules/auth/actions';

import { useQuery } from 'utils';

import logo from 'assets/images/logo.svg';
import styles from './Signup.module.css';
import { routes } from 'routes';

export interface IRenderSteps {
  [key: number]: JSX.Element;
}

export const Signup: FC = () => {
  const plan = useQuery().get('plan') || '';
  // store
  const { registerStep } = useSelector((state: RootState) => state.auth);

  const company = plan === 'enterprise' ? true : false;

  useEffect(() => {
    dispatch(clearAuthError());
  }, []);

  const renderSteps: IRenderSteps = {
    1: company ? <FirstStepCompany /> : <FirstStepClinic />,
    2: <SecondStep />,
    3: company ? <ThirdStepCompany /> : <ThirdStepClinic />,
    4: company ? <FourStepCompany /> : <FourStepClinic />,
  };

  return (
    <div>
      <Container>
        <div className={styles.topWrap}>
          <Link to={routes.signin}>
            <img className={styles.logo} src={logo} alt="Logo" />
          </Link>
          <LanguagesSelect />
        </div>
        {renderSteps[registerStep]}
      </Container>
    </div>
  );
};
